import React, { useState } from "react"

const SearchForm = (props) => {
    const [value, setValue] = useState(props.value)

    return (
        <form method="GET" action="/search">
            <input type="text" name="q" placeholder="Your search" value={value} onChange={({ target }) => setValue(target.value)} />
            <button>Go</button>
        </form>
    )
}

export { SearchForm }
